export function getRandomInteger(floor: number = 0, ceil: number = 10) {
  return Math.round(Math.random() * (ceil - floor) + floor);
}

export function getRandomNumericString(length = 8) {
  return (Math.random() * new Date().getTime() + '').replace('.', '').substr(0, length);
}